<picture>
  <img *ngIf="(Images | keyvalue)?.length" srcset="{{ imageMap.toString() }}" sizes="{{ imageSize.toString() }}" 
    [src]="Images['phone']" alt="">
</picture>